import * as React from "react";

export interface BackgroundColorIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export const BackgroundColorIcon = React.forwardRef<SVGSVGElement, BackgroundColorIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      aria-hidden="true"
      focusable="false"
    >
      <rect width="48" height="48" fill="white" fillOpacity="0.01" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37 37C39.2091 37 41 35.2091 41 33C41 31.5272 39.6667 29.5272 37 27C34.3333 29.5272 33 31.5272 33 33C33 35.2091 34.7909 37 37 37Z"
        fill="currentColor"
      />
      <path d="M20.8535 5.50439L24.389 9.03993" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
      <path
        d="M23.6818 8.33281L8.12549 23.8892L19.4392 35.2029L34.9955 19.6465L23.6818 8.33281Z"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinejoin="round"
      />
      <path d="M12 20.0732L28.961 25.6496" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
      <path d="M4 43H44" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
    </svg>
  ),
);

BackgroundColorIcon.displayName = "BackgroundColorIcon";

export default BackgroundColorIcon;
